import React, { useState } from "react";
import axios from "axios";


const useCRUDController = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
    apiRoute=""
}) => {
    const [data, setData] = useState([])
    const getData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(apiRoute, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                // setData()
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(apiRoute,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(apiRoute,
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(apiRoute,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
        return {
        ResponseData: data,
        getData,
        postData,
        patchData,
        deleteData,
    }
}
export { useCRUDController}
